import React from "react";

export default function ColorFrame8({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <rect
          x="103.614"
          y="28.9432"
          width="68.8409"
          height="34.4205"
          rx="8.82576"
          stroke="#6D2D5E"
          strokeWidth="8.82576"
        />
        <rect
          x="9.17798"
          y="45.7121"
          width="256.83"
          height="202.992"
          rx="13.2386"
          fill="#893976"
        />
        <rect
          x="57.2785"
          y="62.0397"
          width="160.629"
          height="170.337"
          rx="16.3277"
          fill="white"
          stroke="#893976"
          strokeWidth="2.64773"
        />
        <path
          d="M236.535 42.9819C238.039 41.347 240.159 40.4167 242.381 40.4167H258.947C266.259 40.4167 272.186 46.3438 272.186 53.6553V72.7935C272.186 74.68 271.501 76.5025 270.26 77.923C267.183 81.4441 261.719 81.4818 258.593 78.0034L247.421 65.5701L236.535 53.7378C233.738 50.6979 233.738 46.0218 236.535 42.9819Z"
          fill="#AA80F9"
        />
        <path
          d="M38.6508 251.435C37.1467 253.07 35.0267 254 32.8051 254H16.2387C8.92716 254 3.00003 248.073 3.00003 240.761V221.623C3.00003 219.737 3.68422 217.914 4.9257 216.494C8.00315 212.973 13.4668 212.935 16.5925 216.413L27.7651 228.847L38.6508 240.679C41.4475 243.719 41.4475 248.395 38.6508 251.435Z"
          fill="#AA80F9"
        />
        <path
          d="M38.6508 42.9819C37.1467 41.347 35.0267 40.4167 32.8051 40.4167H16.2387C8.92716 40.4167 3.00003 46.3438 3.00003 53.6553V72.7935C3.00003 74.68 3.68422 76.5025 4.9257 77.923C8.00315 81.4441 13.4668 81.4818 16.5925 78.0034L27.7651 65.5701L38.6508 53.7378C41.4475 50.6979 41.4475 46.0218 38.6508 42.9819Z"
          fill="#AA80F9"
        />
        <path
          d="M236.535 251.435C238.039 253.07 240.159 254 242.381 254H258.947C266.259 254 272.186 248.073 272.186 240.761V221.623C272.186 219.737 271.501 217.914 270.26 216.494C267.183 212.973 261.719 212.935 258.593 216.413L247.421 228.847L236.535 240.679C233.738 243.719 233.738 248.395 236.535 251.435Z"
          fill="#AA80F9"
        />
        <rect
          x="111.557"
          y="21"
          width="54.7197"
          height="15.0038"
          rx="4.41288"
          fill="#AA80F9"
        />
        {children}
      </g>
    </svg>
  );
}
